import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUsersService } from '../../admin-users/services/admin-users.service';
import { AuthDataStorageService } from '../services/auth-data-storage.service';

@Component({
  selector: 'ch-totp',
  templateUrl: './totp.component.html',
  styleUrls: ['./totp.component.css'],
})
export class TotpComponent implements OnInit {
  public loading: boolean;
  public verifying: boolean;
  public qrCode: string;
  public totpCode: string;
  public error: string;
  private id: string;
  private secret: string;

  constructor(private authDataStorageService: AuthDataStorageService, private adminUsersService: AdminUsersService, private router: Router) {}

  ngOnInit() {
    this.id = this.authDataStorageService.getLoggedUserId();
  }

  public enable2fa() {
    this.loading = true;
    this.error = '';
    this.adminUsersService.setup2fa(this.id).subscribe(
      data => {
        const response = data.json();
        this.secret = response.secret;
        this.qrCode = response.qrCodeUrl;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.error = 'Failed to generate QR code. Please try again.';
      }
    );
  }

  public continue() {
    if (!this.totpCode || this.totpCode.length !== 6) {
      this.error = 'Please enter a valid 6-digit code.';
      return;
    }

    this.verifying = true;
    this.error = '';
    this.adminUsersService.verify2fa(this.id, { secret: this.secret, totp: parseInt(this.totpCode, 10) }).subscribe(
      () => {
        this.verifying = false;
        this.router.navigateByUrl('/admin/dashboard');
      },
      error => {
        this.verifying = false;
        this.error = 'Invalid verification code. Please try again.';
        this.totpCode = '';
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/totp/totp.component.ts